export default {"src":"/_next/static/media/g-logo.2c51fb4c.svg","height":42,"width":41,"blurWidth":0,"blurHeight":0};